module.exports = __webpack_public_path__ + "media/images/icon-testimonials-4ff2eb25832692b0d7c264a23cc8af52.svg";